/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliveryAreas200ResponseInnerGeometryAnyOf } from './GetDeliveryAreas200ResponseInnerGeometryAnyOf';
import {
    GetDeliveryAreas200ResponseInnerGeometryAnyOfFromJSON,
    GetDeliveryAreas200ResponseInnerGeometryAnyOfFromJSONTyped,
    GetDeliveryAreas200ResponseInnerGeometryAnyOfToJSON,
    GetDeliveryAreas200ResponseInnerGeometryAnyOfToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerGeometryAnyOf';
import type { GetDeliveryAreas200ResponseInnerGeometryAnyOfInner } from './GetDeliveryAreas200ResponseInnerGeometryAnyOfInner';
import {
    GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerFromJSON,
    GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerFromJSONTyped,
    GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerToJSON,
    GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerGeometryAnyOfInner';

/**
 * 
 * @export
 * @interface GetDeliveryAreas200ResponseInnerGeometry
 */
export interface GetDeliveryAreas200ResponseInnerGeometry {
    /**
     * 
     * @type {GetDeliveryAreas200ResponseInnerGeometryAnyOfInner}
     * @memberof GetDeliveryAreas200ResponseInnerGeometry
     */
    center: GetDeliveryAreas200ResponseInnerGeometryAnyOfInner;
    /**
     * 
     * @type {number}
     * @memberof GetDeliveryAreas200ResponseInnerGeometry
     */
    radiusMeters: number;
}

/**
 * Check if a given object implements the GetDeliveryAreas200ResponseInnerGeometry interface.
 */
export function instanceOfGetDeliveryAreas200ResponseInnerGeometry(value: object): value is GetDeliveryAreas200ResponseInnerGeometry {
    if (!('center' in value) || value['center'] === undefined) return false;
    if (!('radiusMeters' in value) || value['radiusMeters'] === undefined) return false;
    return true;
}

export function GetDeliveryAreas200ResponseInnerGeometryFromJSON(json: any): GetDeliveryAreas200ResponseInnerGeometry {
    return GetDeliveryAreas200ResponseInnerGeometryFromJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliveryAreas200ResponseInnerGeometry {
    if (json == null) {
        return json;
    }
    return {
        
        'center': GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerFromJSON(json['center']),
        'radiusMeters': json['radiusMeters'],
    };
}

export function GetDeliveryAreas200ResponseInnerGeometryToJSON(json: any): GetDeliveryAreas200ResponseInnerGeometry {
    return GetDeliveryAreas200ResponseInnerGeometryToJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerGeometryToJSONTyped(value?: GetDeliveryAreas200ResponseInnerGeometry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'center': GetDeliveryAreas200ResponseInnerGeometryAnyOfInnerToJSON(value['center']),
        'radiusMeters': value['radiusMeters'],
    };
}

